import { useMemo } from 'react';
import useSWR from 'swr';

import container from 'src/container';
import { Organization } from 'src/domain/organization';

const {
    cradle: { munduClient },
} = container;

export const useOrganizationGroupsById = (
    organizationId?: string,
): { groupsById?: Map<string, string> } => {
    const { data: organization } = useSWR<Organization>(
        organizationId ? ['organization', organizationId] : null,
        (_key, id) => munduClient.getOrganization(id),
    );

    const groupsById = useMemo(() => {
        const groups = organization?.groups ?? [];
        if (!groups.length) return undefined;

        const groupsByIdMap = new Map(groups.map(group => [group.id, group]));

        const entries: [string, string][] = groups.map(group => {
            const parent = group.parentId
                ? groupsByIdMap.get(group.parentId)
                : undefined;
            const parentLabel = parent?.name || parent?.id;
            const groupLabel = group.name || group.id;
            return [
                group.id,
                parentLabel ? `${parentLabel} | ${groupLabel}` : groupLabel,
            ];
        });

        return new Map<string, string>(entries);
    }, [organization?.groups]);

    return { groupsById };
};
